<ion-content>
  <ion-list>
    <ion-item button [class.hidden]="link.hidden" *ngFor="let link of this.settingLinks">
      <a (click)="this.dismissPopover()" class="w-100" [routerLink]="link.path" routerLinkActive="active">
        <div class="label-container">
          <div class="icon-container">
            <ion-icon [ios]="link.icon + '-outline'" [md]="link.icon + '-sharp'"></ion-icon>
          </div>
          <div class="link-title">{{link.label | translate}}</div>
        </div>
      </a>
    </ion-item>
    <ion-item button (click)="this.logout();">
      <div class="label-container">
        <div class="icon-container">
          <ion-icon name="log-out-outline"></ion-icon>
        </div>
        <div class="link-title">{{'Messages_Logout' | translate}}</div>
      </div>
    </ion-item>
  </ion-list>
</ion-content>
